import API from './API';

class AccountAPI extends API {
  constructor(parameters = {}) {
    super('/Account', parameters);
  }

  /**
   * Handle login request
   *
   * @param data
   * @return
   */
  login(data) {
    return this.submit('post', `${this.endpoint}/Login`, data);
  }

  logout() {
    return this.submit('post', `${this.endpoint}/Logout`);
  }
  getVersionAndCommitHash() {
    return this.submit("get", `${this.endpoint}/Version`);
  }
}

export default AccountAPI;
